export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "+91 97737 56768";
export const PHONE_TEL = "tel:+919773756768";
export const EMAIL = "orders@mahiraagro.com";
export const EMAIL_MAILTO = `mailto:${EMAIL}`;

export const wa = (msg) =>
  `https://wa.me/919773756768?text=${encodeURIComponent(msg)}`;

export const WA_MESSAGES = {
  default: "Hi MAHIRA, I would like to know more about your A2 Gir Cow Ghee.",
  order: (size) =>
    `Hi MAHIRA, I would like to order your A2 Gir Cow Ghee${
      size ? ` (${size})` : ""
    }. Please share the price and delivery details.`,
  pricing: "Hi MAHIRA, could you share the pricing for MAHIRA A2 Gir Cow Ghee?",
  wholesale:
    "Hi MAHIRA, I am interested in a bulk / wholesale enquiry for MAHIRA products.",
  distributor:
    "Hi MAHIRA, I am interested in becoming a distributor for MAHIRA products.",
  international:
    "Hi MAHIRA, I am enquiring about international availability of MAHIRA products.",
};

export const ADDRESS =
  "Sector 39A, Kharghar, Juhi Niharika Absolute, D Wing 302, Navi Mumbai, Maharashtra, India";

export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  "Sector 39A, Kharghar, Navi Mumbai, Maharashtra, India"
)}`;

export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
  "Sector 39A, Kharghar, Navi Mumbai, Maharashtra, India"
)}&output=embed`;

export const IMG = {
  heroJar: "/assets/hero-jar.png",
  lifestyle: "/assets/ghee-lifestyle.png",
  texture: "/assets/ghee-texture.png",
  cow: "https://images.unsplash.com/photo-1673229266917-89abfa3ebc58?q=80&w=1600&auto=format&fit=crop",
  farm: "https://images.unsplash.com/photo-1769429955215-74ea5c9a1cfa?q=80&w=1600&auto=format&fit=crop",
  cuisine:
    "https://images.unsplash.com/photo-1585937421612-70a008356fbe?q=80&w=1600&auto=format&fit=crop",
  jar: "/assets/jar-real.jpg",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
